import { isValid, parseISO } from 'date-fns'

import {
  ContractExtensionMapping,
  employerRelationshipMapping,
} from '@/components/EntityPanels/utils'
import type { Referee } from '@/components/ReferenceDetails/types'
import type { IncomeEmployerReference } from '@/types/Activity'
import type { IncomeProperties } from '@/types/Income'
import { formatDate, parseDate } from '@/utils/date'

export const toReferee = (employerReference: IncomeEmployerReference): Referee => ({
  id: employerReference.subjectId,
  name: employerReference.name,
  email: employerReference.email,
  phone: employerReference.phone,
  jobTitle: employerReference.jobRole ?? undefined,
})

export const toIncomeValue = (income: IncomeProperties): string =>
  `${income?.currency?.symbol ?? ''}${income.value} paid ${income.frequency} ${
    income.averageHoursAWeek ? `(${income.averageHoursAWeek} per week on average)` : ''
  }`

export const toReferenceDetails = (
  employerReference: IncomeEmployerReference,
): Record<string, string> => ({
  ...(employerReference.income
    ? { 'Value of the income': toIncomeValue(employerReference.income) }
    : {}),
  ...(employerReference.guaranteedBonus
    ? { 'Value of the bonus': toIncomeValue(employerReference.guaranteedBonus) }
    : {}),
  ...(employerReference.jobTitle ? { 'Position held': employerReference.jobTitle } : {}),
  ...(employerReference.refereeRelationship
    ? { Relationship: employerRelationshipMapping[employerReference.refereeRelationship] }
    : {}),
  ...(employerReference.contractType
    ? { 'Contract type': employerReference.contractType }
    : {}),
  ...(employerReference.contractFrequency
    ? { 'Employment basis': employerReference.contractFrequency }
    : {}),
  ...(employerReference.startDate &&
  isValid(parseISO(employerReference.startDate)) &&
  parseISO(employerReference.startDate).getTime() > 0
    ? { 'Employment started': formatDate(parseDate(employerReference.startDate)) }
    : {}),
  ...(employerReference.endDate &&
  isValid(parseISO(employerReference.endDate)) &&
  parseISO(employerReference.endDate).getTime() > 0
    ? { 'Employment due to end': formatDate(parseDate(employerReference.endDate)) }
    : {}),
  ...(employerReference.contractExtension
    ? {
        'Contract extension':
          ContractExtensionMapping[employerReference.contractExtension],
      }
    : {}),
})
